export const SETTLEMENTS_ERROR = 'SETTLEMENTS_ERROR'
export const SETTLEMENTS_SUCCESS = 'SETTLEMENTS_SUCCESS'
export const SETTLEMENTS_LOADING = 'SETTLEMENTS_LOADING'
export const SETTLEMENT_CREATION_SET_SPONSOR_SLUG = 'SETTLEMENT_CREATION_SET_SPONSOR_SLUG'
export const SETTLEMENT_CREATION_SET_DATE_FROM = 'SETTLEMENT_CREATION_SET_DATE_FROM'
export const SETTLEMENT_CREATION_SET_DATE_TO = 'SETTLEMENT_CREATION_SET_DATE_TO'
export const SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE = 'SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE'
export const SELECT_SETTLEMENT_FOR_DETAIL = 'SELECT_SETTLEMENT_FOR_DETAIL'
export const SET_SETTLEMENT_DETAIL = 'SET_SETTLEMENT_DETAIL'
export const CLEAN_SETTLEMENT_DETAIL = 'CLEAN_SETTLEMENT_DETAIL'
export const SETTLEMENT_CREATION_BACK_STEP = 'SETTLEMENT_CREATION_BACK_STEP'
export const SETTLEMENT_CREATION_NEXT_STEP = 'SETTLEMENT_CREATION_NEXT_STEP'
export const SET_PENDING_AUTHORIZATIONS = 'SET_PENDING_AUTHORIZATIONS'
export const SET_SETTLEMENT_ID = 'SET_SETTLEMENT_ID'
export const CLEAR_SETTLEMENT_CREATION = 'CLEAR_SETTLEMENT_CREATION'
export const SET_CLAIMS = 'SET_CLAIMS'
export const CLEAR_CLAIMS = 'CLEAR_CLAIMS'
export const SET_EXCLUDED_CLAIMS = 'SET_EXCLUDED_CLAIMS'
export const CLEAR_EXCLUDED_CLAIMS = 'CLEAR_EXCLUDED_CLAIMS'
export const COMPLETE_ADD_AUTHORIZATIONS_STEP = 'COMPLETE_ADD_AUTHORIZATIONS_STEP'
export const SET_SETTLEMENT_CREATION_RESULT = 'SET_SETTLEMENT_CREATION_RESULT'
export const RESET_SETTLEMENT_CREATION_STATE = 'RESET_SETTLEMENT_CREATION_STATE'
export const SET_UPLOAD_SETTLEMENT_FILES_STATUS = 'SET_UPLOAD_SETTLEMENT_FILES_STATUS'
export const SET_SETTLEMENT_SUMMARY = 'SET_SETTLEMENT_SUMMARY'
export const SETTLEMENT_CREATION_SET_COVERAGES = 'SETTLEMENT_CREATION_SET_COVERAGES'
export const SETTLEMENT_DOCUMENTS = 'SETTLEMENT_DOCUMENTS'
export const MANUAL_AUTHORIZATION_TOGGLE = 'MANUAL_AUTHORIZATION_TOGGLE'
export const MANUAL_AUTHORIZATION_SET_QUANTITY = 'MANUAL_AUTHORIZATION_SET_QUANTITY'
export const MANUAL_AUTHORIZATION_SET_AMOUNT = 'MANUAL_AUTHORIZATION_SET_AMOUNT'